import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import xlsx from 'xlsx';
import { validateIdCardNo } from '@/utils/validate';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { correctBatchImportVerify } from '../request';
let xlsxHeaderInfo = ['序号', '姓名', '证件类型', '证件号码', '工种',
// '工种类别',
// '保险方案',
// '劳动合同单位（共同被保险人）',
// '实际工作单位（派遣单位）',
'姓名', '证件类型', '证件号码', '备注'];
import { typeMapObj, ADD, REDUCE, REPLACE, translateReplace, MINPREMIUM } from './util.js';
import mixin from './mixin.js';
let that;
//表头字段
export default {
  props: {
    importVisible: {
      type: Boolean,
      default: false
    },
    effectiveDate: {
      type: String,
      default: ''
    },
    copyInsuredPersonnelList: {
      type: Array,
      default: () => []
    },
    policyInfo: {
      type: Object,
      default: () => {}
    },
    yearDays: {
      type: Number,
      default: 365
    },
    professionInfo: {
      type: Array,
      default: () => {}
    },
    policyPurpose: {
      type: String,
      default: 'other'
    },
    insurancePlan: {
      type: Array,
      default: () => {}
    },
    occupationTypeOptions: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const that = this;
    return {
      current: 0,
      steps: [{
        title: '上传文件'
      }, {
        title: '数据预览'
      }],
      fileList: [],
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation',
        width: 100,
        align: 'center',
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '工种类别'
        },
        dataIndex: 'occupationType',
        key: 'occupationType',
        width: 100,
        align: 'center',
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '保险方案'
        },
        dataIndex: 'insurancePlanName',
        key: 'insurancePlanName',
        width: 100,
        align: 'center',
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '劳动合同单位（共同被保险人）'
        },
        dataIndex: 'contractCompany',
        key: 'contractCompany',
        width: 180,
        align: 'center'
      }, {
        slots: {
          title: '实际工作单位（派遣单位）'
        },
        dataIndex: 'dispatchCompany',
        key: 'dispatchCompany',
        width: 180,
        align: 'center'
      }, {
        slots: {
          title: '类型'
        },
        dataIndex: 'recordType',
        key: 'recordType',
        align: 'center',
        width: 120,
        customRender: (text, record) => {
          return this.$t(typeMapObj[text]) || '-';
        }
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: 'name',
        width: 100,
        align: 'center',
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType',
        align: 'center',
        width: 100,
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        width: 200,
        align: 'center',
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '生效日期'
        },
        dataIndex: 'effectDate',
        key: 'effectDate',
        align: 'center',
        width: 120,
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'premium',
        key: 'premium',
        align: 'center',
        width: 100,
        customRender: (text, record) => {
          return text || '-';
        }
      }, {
        slots: {
          title: '备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        align: 'center',
        width: 150,
        customRender: (text, record) => {
          return text || '-';
        },
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 180,
        key: '9'
      }],
      dataInfo: [],
      fileData: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共') + total + this.$t('条')}`;
        }
      },
      editVisible: false,
      editLine: -1,
      form: {
        occupation: undefined,
        occupationType: '',
        name: undefined,
        identificationType: undefined,
        idNumber: undefined,
        effectDate: undefined,
        premium: undefined,
        remark: undefined,
        insurancePlanCode: undefined,
        contractCompany: '',
        dispatchCompany: ''
      },
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      disableNextButton: false,
      relatedRelationships: [],
      typeMapObj: typeMapObj,
      REDUCE: REDUCE,
      safeguard: [],
      insuredPersonMap: {}
    };
  },
  mixins: [mixin],
  filters: {
    translate(val) {
      translateReplace.forEach(item => {
        if (val.indexOf(item) !== -1) {
          val = val.replace(item, that.$t(item));
        }
      });
      return val;
    }
  },
  computed: {
    rules() {
      return {
        occupation: [{
          required: true,
          message: this.$t('请输入') + this.$t('工种'),
          trigger: 'blur',
          transform: value => {
            return value.trim();
          }
        }, {
          validator: this.validateOccupation,
          trigger: 'blur'
        }],
        insurancePlanCode: [{
          required: true,
          message: '请选择保险方案',
          trigger: 'change'
        }],
        occupationType: [{
          required: true,
          message: this.$t('请输入') + this.$t('工种类别'),
          trigger: 'blur',
          transform: value => {
            return value.trim();
          }
        }],
        dispatchCompany: [{
          required: true,
          trigger: 'blur',
          message: '请输入实际工作单位（派遣单位）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        contractCompany: [{
          required: true,
          trigger: 'blur',
          message: '请输入劳动合同单位（合同主体）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        identificationType: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('名称'),
          transform: value => {
            return value.trim();
          }
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容'),
          transform: value => {
            return value.trim();
          }
        }],
        effectDate: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('签约日期')
        }],
        idNumber: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur',
          transform: value => {
            return value.trim();
          }
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }],
        remark: [{
          max: 200,
          message: this.$t('请输入长度200以内的内容'),
          transform: value => {
            return value.trim();
          }
        }]
      };
    }
  },
  watch: {
    importVisible: {
      handler(newVal) {
        if (!newVal) return;
        this.resetData();
        this.copyInsuredPersonnelList.forEach(item => {
          this.insuredPersonMap[item.idNumber.toLocaleUpperCase()] = item;
        });
        console.log('xlsxHeaderInfo', this.policyPurpose);
        // if (this.policyPurpose === 'other') {
        //   // xlsxHeaderInfo.splice(1, 1);

        //   xlsxHeaderInfo.splice(5, 4);
        //   this.columns = this.columns.filter(
        //     item =>
        //       item.dataIndex !== 'occupationType' ||
        //       item.dataIndex !== 'insurancePlanName' ||
        //       item.dataIndex !== 'contractCompany' ||
        //       item.dataIndex !== 'dispatchCompany'
        //   );
        // }
      }
    },
    policyPurpose: {
      handler(val) {
        console.log('xlsxHeaderInfo', val);
        if (val === 'groupInsurance') {
          xlsxHeaderInfo = ['序号', '姓名', '证件类型', '证件号码', '工种', '工种类别', '保险方案', '劳动合同单位（共同被保险人）', '实际工作单位（派遣单位）', '姓名', '证件类型', '证件号码', '备注'];
        } else {
          xlsxHeaderInfo = ['序号', '姓名', '证件类型', '证件号码', '工种', '姓名', '证件类型', '证件号码', '备注'];
          this.columns = this.columns.filter(item => item.dataIndex !== 'occupationType' && item.dataIndex !== 'insurancePlanName' && item.dataIndex !== 'contractCompany' && item.dataIndex !== 'dispatchCompany');
          console.log(' this.columns', this.columns);
        }
      },
      immediate: true
    }
  },
  created() {
    this.copyInsuredPersonnelList.forEach(item => {
      this.insuredPersonMap[item.idNumber.toLocaleUpperCase()] = item;
    });
    that = this;
  },
  methods: {
    validateOccupation(rule, value, callback) {
      let findOccupation = this.professionInfo.filter(i => {
        var _i$occupation;
        return ((_i$occupation = i.occupation) === null || _i$occupation === void 0 ? void 0 : _i$occupation.replace(/\s/g, '')) === (value === null || value === void 0 ? void 0 : value.replace(/\s/g, ''));
      });
      if (findOccupation.length === 0) {
        callback(new Error(this.$t('工种输入不符，请重新输入!')));
      } else {
        callback();
      }
    },
    validateCard(rule, idcard, callback) {
      let idCardTrim = (idcard === null || idcard === void 0 ? void 0 : idcard.trim()) || '';
      if (!validateIdCardNo(idCardTrim) || idCardTrim == '') {
        callback(new Error(this.$t('请输入18位大陆身份证号')));
      } else {
        callback();
      }
    },
    beforeUpload(file) {
      this.fileValidateStatus = true;
      const imgReg = /(xlsx|xls)$/;
      const filename = file.name;
      const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
      const isExcel = imgReg.test(imgSuffix);
      if (!isExcel) {
        this.fileValidateStatus = false;
        this.$message.error(this.$t('请上传正确的格式'));
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        this.fileValidateStatus = false;
        this.$message.error(this.$t('文件大小超过1M'));
        return;
      }
      this.fileList = [];
      this.fileList = [...this.fileList, file];
      return false;
    },
    back() {
      if (this.current > 0) {
        this.current = 0;
        this.relatedRelationships = [];
      }
    },
    resetData() {
      this.fileList = [];
      this.dataInfo = [];
      this.insuredPersonMap = {};
      this.relatedRelationships = [];
      this.current = 0;
      this.pagination = {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共') + total + this.$t('条')}`;
        }
      };
    },
    next() {
      if (this.fileList.length === 0) {
        this.$message.error(this.$t('请上传文件') + '!');
        return;
      }
      if (this.fileData.length > 1000) {
        this.$message.error(this.$t('导入附件内人员行数不超过1000行'));
        return;
      }
      let validateStatus = this.validateFileForm();
      if (!validateStatus) {
        this.$message.error(this.$t('文件格式不正确'));
        return;
      }
      if (this.current === 0) {
        //下一步 展示表格
        //校验excel文件格式
        this.current++;
        this.dataInfo = [];
        this.pagination = {
          showSizeChanger: true,
          showQuickJumper: true,
          total: 0,
          pageSize: 10,
          // 每页条数
          current: 1,
          showTotal: total => {
            return `${this.$t('共') + total + this.$t('条')}`;
          }
        };
        this.handlerXlsxData(this.fileData);
        this.checkAllReplaceRepeat();
      } else if (this.current === 1) {
        //开始校验  校验完成导入
        let hasErr = false;
        for (let i = 0; i < this.dataInfo.length; i++) {
          var _this$dataInfo$i;
          if (((_this$dataInfo$i = this.dataInfo[i]) === null || _this$dataInfo$i === void 0 || (_this$dataInfo$i = _this$dataInfo$i.errorMessage) === null || _this$dataInfo$i === void 0 ? void 0 : _this$dataInfo$i.length) > 0) {
            hasErr = true;
            let recentErrorPage = parseInt(i / this.pagination.pageSize) + 1;
            this.pagination.current = recentErrorPage;
            break;
          }
        }
        if (!hasErr) {
          let data = cloneDeep(this.dataInfo);
          data.map(item => {
            var _item$idNumber;
            let findOccupation = this.professionInfo.filter(i => {
              var _i$occupation2, _item$occupation;
              return ((_i$occupation2 = i.occupation) === null || _i$occupation2 === void 0 ? void 0 : _i$occupation2.replace(/\s/g, '')) === ((_item$occupation = item.occupation) === null || _item$occupation === void 0 ? void 0 : _item$occupation.replace(/\s/g, ''));
            });
            if (item.recordType === REDUCE) {
              item.effectDate = moment(this.effectiveDate).subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59';
            }
            if (item.recordType === ADD) {
              item.effectDate = moment(this.effectiveDate).format('YYYY-MM-DD') + ' 00:00:00';
            }
            if (findOccupation.length > 0) {
              item.jobNumber = findOccupation[0].jobNumber;
            }
            item.idNumber = ((_item$idNumber = item.idNumber) === null || _item$idNumber === void 0 ? void 0 : _item$idNumber.toLocaleUpperCase()) || '';
            return item;
          });
          this.handlerSortData(data);
          let detail = {
            safeguard: this.safeguard
          };
          let params = {
            policyId: this.policyInfo.id,
            personnelDetailsData: data,
            detail: JSON.stringify(detail)
          };
          //导入前校验
          this.disableNextButton = true;
          correctBatchImportVerify(params).then(res => {
            this.disableNextButton = false;
            if (res.status === 'FAIL') {
              this.$message.error(this.$t('数据校验未通过'));
              this.dataInfo = res.data.map(item => {
                if (item.recordType === REDUCE) {
                  item.effectDate = moment(item.effectDate).add(1, 'days').format('YYYY-MM-DD');
                } else if (item.recordType === ADD) {
                  item.effectDate = moment(item.effectDate).format('YYYY-MM-DD');
                }
                return item;
              });
              //跳转到错误页
              for (let i = 0; i < this.dataInfo.length; i++) {
                var _this$dataInfo$i2;
                if (((_this$dataInfo$i2 = this.dataInfo[i]) === null || _this$dataInfo$i2 === void 0 || (_this$dataInfo$i2 = _this$dataInfo$i2.errorMessage) === null || _this$dataInfo$i2 === void 0 ? void 0 : _this$dataInfo$i2.length) > 0) {
                  let recentErrorPage = parseInt(i / this.pagination.pageSize) + 1;
                  this.pagination.current = recentErrorPage;
                  break;
                }
              }
            } else {
              data.forEach(item => {
                if (item.recordType === REDUCE) {
                  item.effectDate = moment(item.effectDate).add(1, 'days').format('YYYY-MM-DD');
                } else if (item.recordType === ADD) {
                  item.effectDate = moment(item.effectDate).format('YYYY-MM-DD');
                }
              });
              this.$emit('importSave', JSON.parse(JSON.stringify(data)), JSON.parse(JSON.stringify(this.relatedRelationships)));
            }
          }).catch(() => {
            this.disableNextButton = false;
          });
        } else {
          this.$message.error(this.$t('请修改完错误项后继续【下一步】'));
        }
      }
    },
    checkAllReplaceRepeat() {
      //校验替换行是否重复
      let errorMessage = [];
      this.relatedRelationships.forEach(item => {
        let addItem = this.dataInfo.filter(i => i.index === item.addIndex);
        let reduceItem = this.dataInfo.filter(i => i.index === item.reduceIndex);
        if (addItem[0].idNumber === reduceItem[0].idNumber) {
          addItem[0].errorMessage.push('替换人员证件号相同，请确认');
          reduceItem[0].errorMessage.push('替换人员证件号相同，请确认');
        }
      });
      return errorMessage;
    },
    checkOneReplaceRepeat(record, isDelete) {
      //校验替换行是否重复  record 是编辑删除的项  isDelete 是否是删除的时候的
      if (record.recordType === ADD) {
        //编辑的是增员的信息
        let replaceObj = this.relatedRelationships.filter(item => {
          return item.addIndex === record.index;
        });
        if (replaceObj.length > 0) {
          let reduceItem = this.dataInfo.filter(i => i.index === replaceObj[0].reduceIndex);
          if (reduceItem.length > 0 && record.idNumber === reduceItem[0].idNumber && !isDelete) {
            //本人替本人报错
            reduceItem[0].errorMessage = this.checkReduceItem(reduceItem[0]);
            reduceItem[0].errorMessage.push('替换人员证件号相同，请确认');
            record.errorMessage.push('替换人员证件号相同，请确认');
          } else if (reduceItem.length > 0 && isDelete) {
            //如果是删除了增员的信息 重新校验减员的信息
            reduceItem[0].errorMessage = this.checkReduceItem(reduceItem[0]);
          }
        }
      } else if (record.recordType === REDUCE) {
        //编辑的是减员的信息
        let replaceObj = this.relatedRelationships.filter(item => {
          return item.reduceIndex === record.index;
        });
        if (replaceObj.length > 0) {
          let addItem = this.dataInfo.filter(i => i.index === replaceObj[0].addIndex);
          if (addItem.length > 0 && record.idNumber === addItem[0].idNumber && !isDelete) {
            //本人替本人报错
            addItem[0].errorMessage = this.checkAddItem(addItem[0]);
            addItem[0].errorMessage.push('替换人员证件号相同，请确认');
            record.errorMessage.push('替换人员证件号相同，请确认');
          } else if (addItem.length > 0 && isDelete) {
            //如果是删除了减员的信息 重新校验增员的信息
            addItem[0].errorMessage = this.checkAddItem(addItem[0]);
          }
        }
      }
    },
    checkReplacePlanName(record, isDelete) {
      //校验替换行的保险方案是否一致
      if (record.recordType === ADD) {
        let replaceObj = this.relatedRelationships.filter(item => {
          return item.addIndex === record.index;
        });
        if (replaceObj.length > 0) {
          var _reduceItem$, _reduceItem$2;
          let reduceItem = this.dataInfo.filter(i => i.index === replaceObj[0].reduceIndex);
          if (reduceItem.length > 0 && (_reduceItem$ = reduceItem[0]) !== null && _reduceItem$ !== void 0 && _reduceItem$.insurancePlanCode && record.insurancePlanCode !== reduceItem[0].insurancePlanCode && !isDelete) {
            record.errorMessage.push('增员人员保险方案与减员人员保险方案不一致，请修改为' + reduceItem[0].insurancePlanName);
          }
          // if (
          //   reduceItem.length > 0 &&
          //   reduceItem[0]?.occupation &&
          //   record.occupation !== reduceItem[0].occupation &&
          //   !isDelete
          // ) {
          //   record.errorMessage.push('增员人员工种与减员人员工种不一致，请修改为' + reduceItem[0].occupation);
          // }
          if (reduceItem.length > 0 && (_reduceItem$2 = reduceItem[0]) !== null && _reduceItem$2 !== void 0 && _reduceItem$2.occupationType && record.occupationType !== reduceItem[0].occupationType && !isDelete) {
            record.errorMessage.push('增员人员工种类别与减员人员工种类别不一致，请修改为' + reduceItem[0].occupation);
          }
        }
      } else if (record.recordType === REDUCE) {
        let replaceObj = this.relatedRelationships.filter(item => {
          return item.reduceIndex === record.index;
        });
        if (replaceObj.length > 0) {
          let addItem = this.dataInfo.filter(i => i.index === replaceObj[0].addIndex);
          if (addItem.length > 0 && record.insurancePlanCode !== addItem[0].insurancePlanCode && !isDelete) {
            addItem[0].errorMessage.push('增员人员保险方案与减员人员保险方案不一致，请修改为' + record.insurancePlanName);
          }
          // if (addItem.length > 0 && record.occupation && record.occupation !== addItem[0].occupation && !isDelete) {
          //   addItem[0].errorMessage.push('增员人员工种与减员人员工种不一致，请修改为' + record.occupation);
          // }
          if (addItem.length > 0 && record.occupationType && record.occupationType !== addItem[0].occupationType && !isDelete) {
            addItem[0].errorMessage.push('增员人员工种类别与减员人员工种类别不一致，请修改为' + record.occupationType);
          }
        }
      }
    },
    handlerSortData(data) {
      //处理分类数据
      this.safeguard = [];
      let mapObj = {};
      this.relatedRelationships.forEach(item => {
        mapObj[item.addIndex] = [item.addIndex, item.reduceIndex];
      });
      data.forEach(item => {
        var _mapObj$item$index;
        if ((item.recordType === ADD || item.recordType === REDUCE) && !mapObj[item.index]) {
          let obj = {
            type: item.recordType,
            name: item.name,
            idNumber: item.idNumber
          };
          this.safeguard.push(obj);
        } else if (item.recordType === ADD && ((_mapObj$item$index = mapObj[item.index]) === null || _mapObj$item$index === void 0 ? void 0 : _mapObj$item$index.length) > 0) {
          let obj = {
            type: REPLACE
          };
          let reduceItem = data.filter(item1 => {
            if (mapObj[item.index].length === 2) {
              return item1.index == mapObj[item.index][1];
            }
          });
          obj[ADD] = {
            name: item.name,
            idNumber: item.idNumber
          };
          obj[REDUCE] = {
            name: reduceItem.length > 0 ? reduceItem[0].name : '',
            idNumber: reduceItem.length > 0 ? reduceItem[0].idNumber : ''
          };
          this.safeguard.push(obj);
        }
      });
    },
    validateFileForm() {
      var _this$workbook, _this$workbook2, _this$workbook$Merge;
      //校验excel文件格式
      let validateStatus = true;
      let isPass = true;
      console.log(xlsxHeaderInfo, this.tableHeader, ' xlsxHeaderInfo');
      xlsxHeaderInfo.forEach((item, index) => {
        var _String;
        if (this.tableHeader[index] && item !== ((_String = String(this.tableHeader[index])) === null || _String === void 0 ? void 0 : _String.trim())) {
          isPass = false;
        }
      });
      if (!isPass) {
        validateStatus = false;
      }
      // }
      // if (
      //   this.policyPurpose === 'groupInsurance' &&
      //   (this.workbook?.['A2']?.h?.trim() !== '减员信息' || this.workbook?.['F2']?.h?.trim() !== '增员信息')
      // ) {
      //   validateStatus = false;
      // }
      if (((_this$workbook = this.workbook) === null || _this$workbook === void 0 || (_this$workbook = _this$workbook['A2']) === null || _this$workbook === void 0 || (_this$workbook = _this$workbook.h) === null || _this$workbook === void 0 ? void 0 : _this$workbook.trim()) !== '减员信息' || ((_this$workbook2 = this.workbook) === null || _this$workbook2 === void 0 || (_this$workbook2 = _this$workbook2['E2']) === null || _this$workbook2 === void 0 || (_this$workbook2 = _this$workbook2.h) === null || _this$workbook2 === void 0 ? void 0 : _this$workbook2.trim()) !== '增员信息') {
        validateStatus = false;
      }
      if (((_this$workbook$Merge = this.workbook['!merges']) === null || _this$workbook$Merge === void 0 ? void 0 : _this$workbook$Merge.length) !== 3) {
        validateStatus = false;
      }
      // let reduceMerge = this.workbook['!merges']?.[1];
      // let startMerge = this.workbook['!merges']?.[2];
      // if (reduceMerge?.s.c !== 0 || reduceMerge?.s.r !== 1 || reduceMerge?.e.c !== 3 || reduceMerge?.e.r !== 1) {
      //   validateStatus = false;
      // }
      // if (startMerge.s.c !== 4 || startMerge.s.r !== 1 || startMerge.e.c !== 8 || startMerge.e.r !== 1) {
      //   validateStatus = false;
      // }
      if (!this.tableHeader || this.tableHeader.length === 0) {
        validateStatus = false;
      }
      return validateStatus;
    },
    handlerXlsxData() {
      //处理xlsx数据
      let tableData = [];
      let index = 1;
      cloneDeep(this.fileData).map(item => {
        //判断是否有增员信息
        let isAdd = this.hasAddInfo(item);
        //判断是否有减员信息
        let isReduce = this.hasReduceInfo(item);
        if (isAdd && isReduce) {
          //既有增员信息也有减员信息是替换行
          let relationObj = {};
          relationObj.reduceIndex = index;
          //减员
          let reduceObj = this.handlerReduceObj(item, index);
          tableData.push(reduceObj);
          index++;
          relationObj.addIndex = index;
          let addObj = this.handlerAddObj(item, index, reduceObj);
          index++;
          this.relatedRelationships.push(relationObj);
          tableData.push(addObj);
        } else if (isAdd && !isReduce) {
          //只有增员信息
          let addObj = this.handlerAddObj(item, index);
          index++;
          tableData.push(addObj);
        } else if (isReduce && !isAdd) {
          //只有减员信息
          let reduceObj = this.handlerReduceObj(item, index);
          index++;
          tableData.push(reduceObj);
        }
      });
      this.dataInfo = tableData;
    },
    handlerAddObj(item, index, reduceObj) {
      var _String2, _String3, _String4, _String5, _String6;
      let effectDate = moment(this.effectiveDate).format('YYYY-MM-DD');
      let premium = this.calcPrice(this.effectiveDate, this.policyInfo.endAt, this.policyInfo.premium);
      let obj = {
        recordType: ADD,
        occupation: item['工种'] && ((_String2 = String(item['工种'])) === null || _String2 === void 0 ? void 0 : _String2.trim()) || '',
        // occupationType: (item['工种类别'] && String(item['工种类别'])?.trim()) || '',
        name: item['姓名_1'] && ((_String3 = String(item['姓名_1'])) === null || _String3 === void 0 ? void 0 : _String3.trim()) || '',
        identificationType: item['证件类型_1'] && ((_String4 = String(item['证件类型_1'])) === null || _String4 === void 0 ? void 0 : _String4.trim()) || '',
        idNumber: item['证件号码_1'] ? ((_String5 = String(item['证件号码_1'])) === null || _String5 === void 0 || (_String5 = _String5.trim()) === null || _String5 === void 0 ? void 0 : _String5.toLocaleUpperCase()) + '' : '',
        effectDate: effectDate,
        premium: premium || '',
        remark: item['备注'] && ((_String6 = String(item['备注'])) === null || _String6 === void 0 ? void 0 : _String6.trim()) || '',
        index: index
      };
      if (this.policyPurpose === 'groupInsurance') {
        var _String7, _String8, _String9, _String0;
        obj.occupationType = item['工种类别'] && ((_String7 = String(item['工种类别'])) === null || _String7 === void 0 ? void 0 : _String7.trim()) || '';
        let insurancePlanName = item['保险方案'] && ((_String8 = String(item['保险方案'])) === null || _String8 === void 0 ? void 0 : _String8.trim()) || '';
        let insuranceObj = this.insurancePlan.find(i => i.name === insurancePlanName);
        obj.insurancePlanName = insurancePlanName;
        obj.insurancePlanCode = insuranceObj ? insuranceObj.mark : '';
        obj.contractCompany = item['劳动合同单位（共同被保险人）'] && ((_String9 = String(item['劳动合同单位（共同被保险人）'])) === null || _String9 === void 0 ? void 0 : _String9.trim()) || '';
        obj.dispatchCompany = item['实际工作单位（派遣单位）'] && ((_String0 = String(item['实际工作单位（派遣单位）'])) === null || _String0 === void 0 ? void 0 : _String0.trim()) || '';
      }
      obj.errorMessage = this.checkData(obj, reduceObj); //校验错误数据
      //校验保费是否过小
      let premiumError = this.premiumMaxCheck();
      if (premiumError.length > 0) {
        obj.errorMessage.push(...premiumError);
      }
      if (this.policyPurpose === 'groupInsurance' && obj.insurancePlanCode) {
        let insuranceNameError = this.checkInsurancePlanName(obj, reduceObj);
        if (insuranceNameError.length > 0) {
          obj.errorMessage.push(...insuranceNameError);
        }
      }
      return obj;
    },
    checkInsurancePlanName(obj, reduceObj) {
      let errorMessage = [];
      if (reduceObj !== null && reduceObj !== void 0 && reduceObj.insurancePlanCode && obj.insurancePlanCode !== reduceObj.insurancePlanCode) {
        errorMessage.push('替换数据的增员的保险方案与减员的保险方案不同，请修改保险方案为' + reduceObj.insurancePlanName);
      } else if (reduceObj !== null && reduceObj !== void 0 && reduceObj.occupationType && obj.occupationType !== reduceObj.occupationType) {
        errorMessage.push('替换数据的增员的工种类别与减员的工种类别不同，请修改工种类别为' + reduceObj.occupationType);
      }
      // else if (reduceObj?.occupation && obj.occupation !== reduceObj.occupation) {
      //   errorMessage.push('替换数据的增员的工种与减员的工种不同，请修改工种为' + reduceObj.occupation);
      // }

      return errorMessage;
    },
    checkAddItem(record) {
      let message = [];
      message = this.checkData(record); //校验错误数据
      let premiumError = this.premiumMaxCheck();
      if (premiumError.length > 0) {
        message.push(...premiumError);
      }
      return message;
    },
    checkReduceItem(record) {
      var _record$idNumber;
      let idNumber = ((_record$idNumber = record.idNumber) === null || _record$idNumber === void 0 ? void 0 : _record$idNumber.trim()) || '';
      let findObj = this.insuredPersonMap[idNumber === null || idNumber === void 0 ? void 0 : idNumber.toLocaleUpperCase()];
      let message = [];
      message = this.checkData(record); //校验错误数据
      let premiumError = this.premiumMaxCheck();
      if (premiumError.length > 0) {
        message.push(...premiumError);
      }
      if (findObj) {
        // 检测该成员的责任起期是否在生效日期之前
        let dateError = this.reduceStartAtCheck(findObj);
        if (dateError.length > 0) {
          message.push(...dateError);
        }
      }
      return message;
    },
    handlerReduceObj(item, index) {
      var _String1, _String10, _String11, _String12, _String13;
      //生成减员数据对象
      let idNumber = ((_String1 = String(item['证件号码'])) === null || _String1 === void 0 ? void 0 : _String1.trim()) || '';
      let findObj = this.insuredPersonMap[idNumber === null || idNumber === void 0 ? void 0 : idNumber.toLocaleUpperCase()];
      let premium = this.calcPrice(this.effectiveDate, this.policyInfo.endAt, this.policyInfo.premium);
      let obj = {
        recordType: REDUCE,
        occupation: findObj ? (_String10 = String(findObj['occupation'])) === null || _String10 === void 0 ? void 0 : _String10.trim() : '',
        // occupationType: findObj ? String(findObj['occupationType'])?.trim() : '',
        // insurancePlanName: findObj ? String(findObj['insurancePlanName'])?.trim() : '',
        // insurancePlanCode: findObj ? String(findObj['insurancePlanCode'])?.trim() : '',
        name: item['姓名'] ? (_String11 = String(item['姓名'])) === null || _String11 === void 0 ? void 0 : _String11.trim() : '',
        identificationType: item['证件类型'] ? (_String12 = String(item['证件类型'])) === null || _String12 === void 0 ? void 0 : _String12.trim() : '',
        idNumber: item['证件号码'] ? ((_String13 = String(item['证件号码'])) === null || _String13 === void 0 || (_String13 = _String13.trim()) === null || _String13 === void 0 ? void 0 : _String13.toLocaleUpperCase()) + '' : '',
        effectDate: moment(this.effectiveDate).format('YYYY-MM-DD'),
        premium: premium || '',
        remark: '',
        index: index
      };
      if (this.policyPurpose === 'groupInsurance' && findObj) {
        var _String14, _String15, _String16, _String17, _String18;
        obj.occupationType = findObj ? (_String14 = String(findObj['occupationType'])) === null || _String14 === void 0 ? void 0 : _String14.trim() : '';
        obj.insurancePlanName = findObj ? (_String15 = String(findObj['insurancePlanName'])) === null || _String15 === void 0 ? void 0 : _String15.trim() : '';
        obj.insurancePlanCode = findObj ? (_String16 = String(findObj['insurancePlanCode'])) === null || _String16 === void 0 ? void 0 : _String16.trim() : '';
        obj.contractCompany = findObj ? (_String17 = String(findObj['contractCompany'])) === null || _String17 === void 0 ? void 0 : _String17.trim() : '';
        obj.dispatchCompany = findObj ? (_String18 = String(findObj['dispatchCompany'])) === null || _String18 === void 0 ? void 0 : _String18.trim() : '';
      }
      obj.errorMessage = this.checkData(obj); //校验错误数据
      let premiumError = this.premiumMaxCheck();
      if (premiumError.length > 0) {
        obj.errorMessage.push(...premiumError);
      }
      if (findObj) {
        // 检测该成员的责任起期是否在生效日期之前
        let dateError = this.reduceStartAtCheck(findObj);
        if (dateError.length > 0) {
          obj.errorMessage.push(...dateError);
        }
      }
      return obj;
    },
    reduceStartAtCheck(findObj) {
      //检测减员责任起期是否在生效日期之前
      let errorMessage = [];
      let effectiveDate = moment(this.effectiveDate).format('YYYY-MM-DD') + ' 00:00:00';
      let isBefore = moment(findObj.startAt).subtract(1, 'seconds').isBefore(effectiveDate);
      if (!isBefore) {
        errorMessage.push('责任止期早于该人员的责任起期，请重新选择生效日期');
      }
      return errorMessage;
    },
    hasAddInfo(item) {
      //生成增员数据对象  因为减员也有姓名、证件类型、证件号码 所以增员的数据收集出来就带了_1
      const headerText = ['工种', '姓名_1', '证件类型_1', '证件号码_1', '备注'];
      // if (this.policyPurpose === 'groupInsurance') {
      //   headerText.splice(1, 0, '工种类别');
      // }
      //是否有添加数据
      let hasAdd = false;
      headerText.forEach(i => {
        var _String19;
        if (item[i] && (_String19 = String(item[i])) !== null && _String19 !== void 0 && _String19.trim()) {
          hasAdd = true;
        }
      });
      return hasAdd;
    },
    hasReduceInfo(item) {
      const headerText = ['序号', '姓名', '证件类型', '证件号码'];
      // if (this.policyPurpose === 'groupInsurance') {
      //   headerText.splice(1, 0, '工种类别');
      // }
      //是否有删除数据
      let hasReduce = false;
      headerText.forEach((i, index) => {
        var _String20;
        if (item[i] && (_String20 = String(item[i])) !== null && _String20 !== void 0 && _String20.trim() && i !== headerText[0]) {
          hasReduce = true;
        }
      });
      return hasReduce;
    },
    checkData(item) {
      var _String21, _String22, _String23, _String24, _String25, _String26, _String27;
      //校验数据是否有误
      let errorMessage = [];
      let reg = /^.{2,15}$/;
      //校验减员是否在保障中
      let occupation = ((_String21 = String(item.occupation)) === null || _String21 === void 0 ? void 0 : _String21.trim()) || '';
      if (!occupation) {
        errorMessage.push('工种为空');
      }
      if (occupation && !reg.test(occupation)) {
        errorMessage.push('工种仅限输入2-15字符');
      }
      if (occupation && this.professionInfo.length > 0) {
        let findOccupation = this.professionInfo.filter(i => {
          var _i$occupation3, _item$occupation2;
          return ((_i$occupation3 = i.occupation) === null || _i$occupation3 === void 0 ? void 0 : _i$occupation3.replace(/\s/g, '')) === ((_item$occupation2 = item.occupation) === null || _item$occupation2 === void 0 ? void 0 : _item$occupation2.replace(/\s/g, ''));
        });
        if (findOccupation.length === 0) {
          errorMessage.push('工种输入不符，请重新输入!');
        }
      }
      let occupationType = ((_String22 = String(item.occupationType)) === null || _String22 === void 0 ? void 0 : _String22.trim()) || '';
      if (!occupationType && this.policyPurpose === 'groupInsurance') {
        errorMessage.push('工种类别为空');
      }
      let insurancePlanName = ((_String23 = String(item.insurancePlanName)) === null || _String23 === void 0 ? void 0 : _String23.trim()) || '';
      if (!insurancePlanName && this.policyPurpose === 'groupInsurance') {
        errorMessage.push('保险方案为空');
      }
      //校验身份证号
      let identificationType = ((_String24 = String(item.identificationType)) === null || _String24 === void 0 ? void 0 : _String24.trim()) || '';
      if (!identificationType) {
        errorMessage.push('证件类型为空');
      }
      if (identificationType && identificationType !== this.identificationTypeData[0].label) {
        errorMessage.push('证件类型输入值与此单元格数据不匹配');
      }
      let name = ((_String25 = String(item.name)) === null || _String25 === void 0 ? void 0 : _String25.trim()) || '';
      if (!name) {
        errorMessage.push('姓名为空');
      }
      if (name && !reg.test(name)) {
        errorMessage.push('姓名仅限输入2-15字符');
      }
      let idNumber = ((_String26 = String(item.idNumber)) === null || _String26 === void 0 ? void 0 : _String26.trim()) || '';
      if (!idNumber) {
        errorMessage.push('证件号码为空');
      }
      if (idNumber && !validateIdCardNo(idNumber)) {
        errorMessage.push('身份证号有误');
      } else if (idNumber && !this.insuredPersonMap[idNumber] && item.recordType === REDUCE) {
        errorMessage.push('导入人员不符合减员规则,保障状态非保障中');
      }
      let remark = ((_String27 = String(item.remark)) === null || _String27 === void 0 ? void 0 : _String27.trim()) || '';
      if (remark && remark.length > 200) {
        errorMessage.push('备注输入超过200字符');
      }
      return errorMessage;
    },
    remove() {
      this.tableHeader = [];
      this.fileList = [];
    },
    handleStandardTableChange(val) {
      this.pagination = val;
    },
    getClassName(item) {
      var _item$errorMessage;
      return ((_item$errorMessage = item.errorMessage) === null || _item$errorMessage === void 0 ? void 0 : _item$errorMessage.length) > 0 ? 'red-row-class' : '';
    },
    handleChange(info) {
      var _info$fileList;
      if (!this.fileValidateStatus) {
        return;
      }
      if (!info.file) {
        this.dataInfo = [];
        return;
      }
      this.workbook = {};
      this.tableHeader = [];
      const fileReader = new FileReader();
      fileReader.onload = e => {
        let binaryData = e.target.result;
        let workbook = xlsx.read(binaryData, {
          type: 'buffer',
          cellDates: true
        });
        const wsname = workbook.SheetNames[0]; //取第一张表
        if (workbook.Sheets[wsname]['!ref']) {
          let ref = workbook.Sheets[wsname]['!ref'].replace('A1', 'A3');
          this.workbook = workbook.Sheets[wsname];
          this.tableHeader = this.getHeaderRow(workbook.Sheets[wsname]);
          this.fileData = xlsx.utils.sheet_to_json(workbook.Sheets[wsname], {
            range: ref
          }); //生成json表格内容
        }
      };
      if ((_info$fileList = info.fileList) !== null && _info$fileList !== void 0 && _info$fileList.length) {
        fileReader.readAsArrayBuffer(info.fileList[0].originFileObj);
      }
    },
    editRecord(record, index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.dataInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      this.editLine = index;
      this.editVisible = true;
      this.$refs.dataFrom && this.$refs.dataFrom.resetFields();
      this.form.name = record['name'];
      this.form.occupation = record['occupation'];
      this.form.recordType = record['recordType'];
      this.form.effectDate = record['effectDate'];
      this.form.remark = record['remark'];
      this.form.identificationType = record['identificationType'];
      this.form.idNumber = record['idNumber'];
      this.form.premium = record['premium'];
      if (this.policyPurpose === 'groupInsurance') {
        this.form.occupationType = record['occupationType'] || '';
        this.form.insurancePlanCode = record['insurancePlanCode'] || undefined;
        this.form.contractCompany = record['contractCompany'] || '';
        this.form.dispatchCompany = record['dispatchCompany'] || '';
      }
      // this.$nextTick(() => {
      //   this.$refs.dataFrom && this.$refs.dataFrom.validate();
      // });
    },
    getHeaderRow(sheet) {
      const headers = []; // 定义数组，用于存放解析好的数据
      let ref = sheet['!ref'].replace('A1', 'A3');
      const range = xlsx.utils.decode_range(ref); // 读取sheet的单元格数据
      let C;
      //表格开始行
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[xlsx.utils.encode_cell({
          c: C,
          r: R
        })];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = xlsx.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers; // 经过上方一波操作遍历，得到最终的第一行头数据
    },
    deleteRecord(index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.dataInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      let deleteIndex = (this.pagination.current - 1) * this.pagination.pageSize + index;
      let deleteItem = this.dataInfo[deleteIndex];
      let relationIndex = this.relatedRelationships.findIndex(i => i.addIndex === deleteItem.index || i.reduceIndex === deleteItem.index);
      //删除后重新校验
      this.checkOneReplaceRepeat(deleteItem, true);
      this.checkReplacePlanName(deleteItem, true);
      if (relationIndex !== -1) {
        //如果删除的是替换数据的一方  删除绑定的关联关系
        this.relatedRelationships.splice(relationIndex, 1);
      }
      this.dataInfo.splice(deleteIndex, 1);
    },
    handleCancel() {
      this.$emit('update:importVisible', false);
    },
    editCancel() {
      this.editVisible = false;
    },
    handleOk() {
      //修改数据
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          var _this$form$idNumber, _this$form$name, _this$form$occupation2, _this$form$identifica, _this$form$idNumber2, _this$form$remark;
          if (this.professionInfo.length > 0) {
            let findOccupation = this.professionInfo.filter(i => {
              var _i$occupation4, _this$form$occupation;
              return ((_i$occupation4 = i.occupation) === null || _i$occupation4 === void 0 ? void 0 : _i$occupation4.replace(/\s/g, '')) === ((_this$form$occupation = this.form.occupation) === null || _this$form$occupation === void 0 ? void 0 : _this$form$occupation.replace(/\s/g, ''));
            });
            if (findOccupation.length === 0) {
              this.$message.error(this.$t('工种输入不符，请重新输入!'));
              return;
            }
          }
          let idNumber = ((_this$form$idNumber = this.form.idNumber) === null || _this$form$idNumber === void 0 ? void 0 : _this$form$idNumber.trim()) || '';
          let findObj = this.insuredPersonMap[idNumber.toLocaleUpperCase()];
          //校验减员数据 的工种 工种分类  保险方案是否匹配
          let validateReduceObjStatus = this.validateReduceObj(findObj);
          if (!validateReduceObjStatus) {
            return;
          }
          this.editVisible = false;
          let editIndex = (this.pagination.current - 1) * this.pagination.pageSize + this.editLine;
          this.dataInfo[editIndex].name = (_this$form$name = this.form['name']) === null || _this$form$name === void 0 ? void 0 : _this$form$name.trim();
          this.dataInfo[editIndex].occupation = (_this$form$occupation2 = this.form['occupation']) === null || _this$form$occupation2 === void 0 ? void 0 : _this$form$occupation2.trim();
          // this.dataInfo[editIndex].occupationType = this.form['occupationType']?.trim();
          this.dataInfo[editIndex].identificationType = (_this$form$identifica = this.form['identificationType']) === null || _this$form$identifica === void 0 ? void 0 : _this$form$identifica.trim();
          this.dataInfo[editIndex].idNumber = (_this$form$idNumber2 = this.form['idNumber']) === null || _this$form$idNumber2 === void 0 ? void 0 : _this$form$idNumber2.trim().toLocaleUpperCase();
          this.dataInfo[editIndex].effectDate = this.form['effectDate'];
          this.dataInfo[editIndex].premium = this.form['premium'];
          this.dataInfo[editIndex].remark = (_this$form$remark = this.form['remark']) === null || _this$form$remark === void 0 ? void 0 : _this$form$remark.trim();
          if (this.policyPurpose === 'groupInsurance') {
            var _this$form$occupation3;
            //如果是团险的方案的话
            this.dataInfo[editIndex].occupationType = (_this$form$occupation3 = this.form['occupationType']) === null || _this$form$occupation3 === void 0 ? void 0 : _this$form$occupation3.trim();
            let insuranceObj = this.insurancePlan.find(i => i.mark === this.form.insurancePlanCode);
            this.dataInfo[editIndex].insurancePlanName = insuranceObj ? insuranceObj.name : '';
            this.dataInfo[editIndex].insurancePlanCode = this.form.insurancePlanCode;
            this.dataInfo[editIndex].contractCompany = this.form.contractCompany;
            this.dataInfo[editIndex].dispatchCompany = this.form.dispatchCompany;
          }
          // 修改后校验数据是否有误
          this.dataInfo[editIndex].errorMessage = this.checkData(this.dataInfo[editIndex]);
          // 修改后校验保费是否过小
          let premiumError = this.premiumMaxCheck();
          if (premiumError.length > 0) {
            this.dataInfo[editIndex].errorMessage.push(...premiumError);
          }
          if (findObj && this.dataInfo[editIndex].recordType === REDUCE) {
            // 检测该成员的责任起期是否在生效日期之前
            let dateError = this.reduceStartAtCheck(findObj);
            if (dateError.length > 0) {
              this.dataInfo[editIndex].errorMessage.push(...dateError);
            }
          }
          this.checkOneReplaceRepeat(this.dataInfo[editIndex], false);
          if (this.policyPurpose === 'groupInsurance') {
            //校验替换行的保险方案、工种、工种类别是否一致
            this.checkReplacePlanName(this.dataInfo[editIndex], false);
          }
        }
      });
    },
    validateReduceObj(findObj) {
      var _this$form$occupation4, _findObj$occupation, _this$form$identifica2;
      //校验减员数据 的工种 工种分类  保险方案是否匹配
      let valiadteStatus = true;
      if (findObj && ((_this$form$occupation4 = this.form.occupation) === null || _this$form$occupation4 === void 0 ? void 0 : _this$form$occupation4.replace(/\s/g, '')) !== (findObj === null || findObj === void 0 || (_findObj$occupation = findObj.occupation) === null || _findObj$occupation === void 0 ? void 0 : _findObj$occupation.replace(/\s/g, ''))) {
        //校验工种是否符合
        this.$message.error(this.$t('工种输入不符，请重新输入!'));
        valiadteStatus = false;
      }
      if (this.policyPurpose === 'groupInsurance') {
        if (findObj && this.form.insurancePlanCode !== (findObj === null || findObj === void 0 ? void 0 : findObj.insurancePlanCode)) {
          //校验保险方案是否符合
          this.$message.error(this.$t('保险方案不符，请重新选择!'));
          valiadteStatus = false;
        }
        if (findObj && this.form.occupationType !== (findObj === null || findObj === void 0 ? void 0 : findObj.occupationType)) {
          //校验工种类别是否符合
          this.$message.error(this.$t('工种类别不符，请重新选择!'));
          valiadteStatus = false;
        }
        if (findObj && this.form.contractCompany !== (findObj === null || findObj === void 0 ? void 0 : findObj.contractCompany)) {
          //校验劳动合同单位（共同被保险人）是否符合
          this.$message.error(this.$t('劳动合同单位（共同被保险人）不符，请重新选择!'));
          valiadteStatus = false;
        }
        if (findObj && this.form.dispatchCompany !== (findObj === null || findObj === void 0 ? void 0 : findObj.dispatchCompany)) {
          //校验实际工作单位（派遣单位）是否符合
          this.$message.error(this.$t('实际工作单位（派遣单位）不符，请重新选择!'));
          valiadteStatus = false;
        }
      }
      let identificationType = ((_this$form$identifica2 = this.form.identificationType) === null || _this$form$identifica2 === void 0 ? void 0 : _this$form$identifica2.trim()) || '';
      if (identificationType !== this.identificationTypeData[0].label) {
        this.$message.error(this.$t('证件类型输入值与此单元格数据不匹配'));
        valiadteStatus = false;
      }
      return valiadteStatus;
    },
    premiumMaxCheck() {
      let errorMessage = [];
      let price = this.calcRealyPrice(this.effectiveDate, this.policyInfo.endAt, this.policyInfo.premium);
      if (price > 0 && price < MINPREMIUM) {
        errorMessage.push('保费金额过小无法计算，请联系平台管理员');
      }
      return errorMessage;
    },
    download() {
      //下载模板
      let url = 'https://insurforce1.oss-cn-beijing.aliyuncs.com/insurforce/policy/%E6%89%B9%E6%94%B9/%E6%89%B9%E6%94%B9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx';
      if (this.policyPurpose === 'groupInsurance') {
        url = 'https://insurforce1.oss-cn-beijing.aliyuncs.com/insurforce/policy/%E6%89%B9%E6%94%B9/%E6%89%B9%E6%94%B9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFNEW1.xlsx';
      }
      let filename = this.$t('批改导入模板') + '.xlsx';
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('download', filename);
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 下载完成移除元素
      window.URL.revokeObjectURL(url); // 释放掉blob对象
    },
    changeInsurancePlan(value) {
      //选择保险方案
      this.form.occupationType = this.occupationTypeOptions[value] || '';
      this.$refs.dataFrom && this.$refs.dataFrom.validateField('occupationType');
    }
  }
};